/**
 * @module Actions/App
 * @desc App Actions
 */

import { push } from 'react-router-redux';
import uuid from 'uuid/v4';

import { ActionTypes } from 'constants/index';

/**
 * Change route path.
 *
 * @param {string} pathname
 * @param {Object} [options]
 * @param {string} [options.param]
 * @param {string} [options.query]
 * @param {Object} [options.state]
 *
 * @returns {function}
 */
export function goTo(pathname, options = {}) {
  return push({
    pathname,
    search: options.search,
    state: options.state,
  });
}

/**
 * Hide message.
 *
 * @param {string} id
 * @returns {Object}
 */
export function hideAlert(id: string): Object {
  return {
    type: ActionTypes.HIDE_ALERT,
    payload: { id },
  };
}

/**
 * Show a message.
 *
 * @param {string} message
 * @param {Object} options
 * @param {string} options.type - Type of the alert. Available: success, error, warning, info, black
 * @param {number} [options.timeout] - Delay in seconds for the notification go away. Set this to 0 to not auto-dismiss the notification
 * @param {string} [options.position]
 * @param {string} [options.icon]
 *
 * @returns {Object}
 */
export function showAlert(message: string, options: Object): Object {
  const timeout = options.type === 'error' ? 0 : 5;

  return {
    type: ActionTypes.SHOW_ALERT,
    payload: {
      id: options.id || uuid(),
      icon: options.icon,
      message,
      position: options.position || 'bottom-right',
      type: options.type,
      timeout: !isNaN(options.timeout) ? options.timeout : timeout,
    },
  };
}

export function drawerStatusChange(draweropened) {
  return {
    type: ActionTypes.DRAWER_CHANGE,
    payload: { draweropened },
  };
}

export function closeIntro() {
  return {
    type: ActionTypes.CLOSE_INTRO,
    payload: { },
  };
}

export function showIntro() {
  return {
    type: ActionTypes.SHOW_INTRO,
    payload: { },
  };
}

export function getNodes(tag) {
  return {
    type: ActionTypes.GET_NODES,
    payload: { tag },
  };
}

export function getEdges() {
  return {
    type: ActionTypes.GET_EDGES,
    payload: { },
  };
}

export function setDetail(data) {
  return {
    type: ActionTypes.SET_DETAIL,
    payload: { data },
  };
}

export function getHtml() {
  return {
    type: ActionTypes.GET_HTML,
    payload: { },
  };
}

export function infoDrawerStatusChange(draweropened) {
  return {
    type: ActionTypes.INFO_DRAWER_CHANGE,
    payload: { draweropened },
  };
}

export function getNodesByCountry(country) {
  return {
    type: ActionTypes.GET_NODES_BY_COUNTRY,
    payload: { country },
  };
}

export function setNodes(nodes) {
  return {
    type: ActionTypes.SET_NODES,
    payload: { nodes },
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/app.js